import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { ProductDetailPage  } from './pages/product-detail/product-detail';
import { ProductDetailPageFull } from './pages/product-detail/product-detail.full';
import { ProductDetailCommon } from './pages/product-detail/product-detail.common';
import { ProductData } from'./providers/product-data';

//Export
export { ProductDetailPage } from './pages/product-detail/product-detail';
export { ProductDetailPageFull } from './pages/product-detail/product-detail.full';

@NgModule({
    imports: [
        IonicModule,
    ],
    declarations: [
        ProductDetailPage,
        ProductDetailPageFull,
        
    ],
    exports: [
        ProductDetailPage,
        ProductDetailPageFull,
        
    ],
    bootstrap: [],
    entryComponents: [
        ProductDetailPage,
        ProductDetailPageFull,
        
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, ProductData, ProductDetailCommon]
})
export class ProductModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: ProductDetailPage, fullComponent: ProductDetailPageFull, name: 'Product Detail', segment: 'product-detail' },
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/product/product.module.ts